import React from 'react';
import PropTypes from 'prop-types';

import env from 'Env';
import { getAllSeo } from 'Config/lang';
import NoIndex from 'Components/SEO/NoIndex';
import { LinkTag } from 'Components/SEO/Tags';

const allowedCodes = getAllSeo().map(lang => lang.code);

export default function AlternativeMetaTags({ path }) {
  if (typeof path === 'undefined') {
    return false;
  }

  const cleanPath = path.replace('-?', '?').replace(/-$/, '');

  return (
    <React.Fragment>
      <LinkTag rel="alternate" hrefLang="x-default" href={`${env.appProtocol}://${env.appUrl}/en/${cleanPath}`} />
      {getAllSeo().map(lang => <LinkTag rel="alternate" key={lang.code} hrefLang={lang.code} href={`${env.appProtocol}://${env.appUrl}/${lang.code}/${cleanPath}`} />)}
      {(!allowedCodes.includes(window.locale)) &&
        <NoIndex noFollow />
      }
    </React.Fragment>
  );
}

AlternativeMetaTags.propTypes = {
  path: PropTypes.string.isRequired,
};
